import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import { map, take, takeUntil } from 'rxjs/operators';
import {AuthService} from './auth.service';
import {v4 as uuidv4} from 'uuid';
import {ParamService} from './param.service';
import {properties} from './../../../environments/properties';
import axios from 'axios';

@Injectable()
export class SubscriptionService {

    banner = this.paramService.banner;
    currentTime = new Date();
    loadTenders$ = new BehaviorSubject(null)
    messageCenterData$: BehaviorSubject<any> = new BehaviorSubject<any>({})
    private properties = properties;

    constructor(public authService: AuthService,
                private paramService: ParamService,
                public _http: HttpClient) {
    }

    getApplicationDomainURL(bannerOveride: string = null) {
        let domain;
        let banner = this.banner;
        if (window.location.href.indexOf('local') > 0) {
            domain = 'https://www-qa1.' + banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }
    
    getApplicationDomainRedirectBannerURL(bannerOveride) {
      let domain;
      let currentBanner = this.banner;
      if (window.location.href.indexOf('local') > 0) {
        domain = 'https://www-qa1.' + bannerOveride + '.com';
      } else {
        domain = 'https://' + window.location.host;
        domain = domain.replace(currentBanner, bannerOveride);
      }
      return domain;
    }

    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserInfoCall() {
      this.banner = this.paramService.banner;
      let url;
      let options = {};
      if (window.location.href.indexOf('local') > 0) {
        // Using Unified Banners Call, if not unified, remove /unified/ from the url path
        url = this.getApplicationDomainURL() + '/bin/safeway/unified/userinfo?banner=' + this.banner + '&rand=' + Math.random();
        console.log('TokenUserInfo ->', url);
        options['withCredentials'] = true;
      } else {
        // Using Unified Banners Call, if not unified, remove /unified/ from the url path
        url = '/bin/safeway/unified/userinfo?banner=' + this.banner;
      }
      return this._http.get(url, options);
    }

    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid'],
            exp: oktaToken['exp'],
            firstname: oktaToken['fnm'],
            lastname: oktaToken['lnm']
        };
        return userClaims;
    }

    public getUserSubscriptionDetails(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getSubscriptionApiConfig.url.replace('{gid}', userInfo.customerId);
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;

        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options);
    }

    public getUserEnrollmentDetails(userInfo, planType, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getSubscriptionApiConfig.url.replace('{uuid}', userInfo.customerId).replace('{gid}', planType);
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;

        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options);
    }

    public getTenders(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getTendersApiConfig.url.replace('{uuid}', userInfo.UUID)
        let headerObj = environment[currentEnvironment].subscriptionHeaders.paymentOptions;
        var isoDate = this.currentTime.toISOString();
        const options = {
            headers: {
                ...headerObj,
                'Date': `${isoDate}`,
                'storeId': '9999',
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4(),
                'x-swy-request-id': uuidv4()
            }
        };
        return this._http.get(url, options)
    }

    

    public getPlans(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getPlansApiConfig.url;
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options)
    }

    public changePlan(userInfo, requestObj, planType, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].changePlanApiConfig.url.replace('{gid}', planType);
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };

        return this._http.post(url, requestObj, options);
    }

    public getUserProfileInfo(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getUserProfileInfo.url.replace('{gid}', userInfo.customerId);
        let headerObj = environment[currentEnvironment].subscriptionHeaders.ucaHttpOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options);
    }

    public getTerms(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getTermsInfoApi.url + '/' + userInfo.customerId
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options).pipe(
          map((data) => {
            if (data['content']) {
              data['content'] = data['content'].replace(/\(displayableBanner\)/g,window['AB'].userInfo.displayableBanner);
              data['content'] = data['content'].replace(/\(banner\)/g,window['AB'].userInfo.banner);
              data['content'] = data['content'].replace(/\(banner4U\)/g,window['AB'].userInfo.displayableBanner);
              data['content'] = data['content'].replace(/\(bannerName\)/g,window['AB'].userInfo.displayableBanner);
            }
            return data;
          })
        );
    }

    public reinstateSubscription(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].reinstateAPI + userInfo.customerId;
        let headerObj = environment[currentEnvironment].subscriptionHeaders.reinstateOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        const jwtClaims = this.getUserClaims(userInfo);
        const reinstateRequestObj = {
            "createdBy": jwtClaims.firstname + ' ' + jwtClaims.lastname,
            "gid": userInfo.customerId
        };
        return this._http.post(url, reinstateRequestObj, options);
    }

    public getCancelReasons(userInfo, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].getCancelReasonsApiConfig.url;
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };
        return this._http.get(url, options)
    }

    public cancelSubscription(userInfo, cancelReason, cancelComments, currentEnvironment): Observable<any> {
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].cancelSubscriptionPlanApiConfig.url.replace('{gid}', userInfo.customerId);
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;
        this.replaceHeaderBanner(headerObj);
        const userResponse = JSON.stringify({
            'reasonCode': cancelReason,
            'userComments': cancelComments
        })
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
                'x-swy-correlation-id': uuidv4()
            }
        };

        return this._http.post(url, userResponse, options)
    }

    public getFreshPassBenefitsJSONAPI(currentEnvironment) {
      let url;

      if (this.banner === 'jewelosco') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassLPMaster_Jewelosco_CASS;
      } else if (this.banner === 'acmemarkets')  {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassLPMaster_Acme_CASS;
      } else {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].aemFreshPassBenefitsJSONURL;
      }
      return axios.get(url);
    }

    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy-banner']) {
              header['x-swy-banner'] = header['x-swy-banner'].replace(/\{banner\}/g, this.banner);
          }
        }
    }

    errorHandling = function (errorStatusCode, errorField, errorObj) {
        var message = '';
        if (errorStatusCode && errorObj && errorObj.errorCode) {
            switch (errorObj.errorCode) {
                case 'OSMS-SUBSCRIPTION-0009':
                    message = this.properties.invalidReasonCode
                    break;
                case 'OSMS-SUBSCRIPTION-00013':
                    message = this.properties.cancelDuringBatchProcess;
                    break;
                case 'OSMS-SUBSCRIPTION-00014':
                    message = this.properties.cancelWithinBufferTime;
                    break;
                case 'OSMS-SUBSCRIPTION-0007':
                    message = this.properties.serverError;
                    break;
                case 'OSMS-SUBSCRIPTION-0000':
                    message = this.properties.unknownError;
                    break;
                case 'OSMS-SUBSCRIPTION-00021':
                    message = this.properties.subsPaymentError;
                    break;
                case 'OSMS-SUBSCRIPTION-00022':
                    message = this.properties.cardUnacceptedError;
                    break;
                default:
                    message = this.properties.subsDefaultError;
                    break;
            }
        } else {
            message = this.properties.subsDefaultError;
        }
        return message;
    };

    public convertDate = function (strDate) {
        const date = new Date(strDate);
        if (!isNaN(date.getTime())) {
            let year = date.toLocaleString("en", {year: "numeric"});
            let month = date.toLocaleString("en", {month: "numeric"});
            let dt = date.toLocaleString("en", {day: "numeric"})
            return month + '/' + dt + '/' + year;
        }
    };

    convertDateByMonthName = function (strDate) {
        const date = new Date(strDate);
        if (!isNaN(date.getTime())) {
            let year = date.toLocaleString("en", {year: "numeric"});
            let month = date.toLocaleString("en", {month: "long"});
            let dt = date.toLocaleString("en", {day: "numeric"})
            return month + ' ' + dt + ', ' + year;
        }
    }

    getTrialPlanStatus(data) {
        if ((data.status.toLowerCase() === 'trial') || (data.status.toLowerCase() === 'processing' && data.previousStatus && data.previousStatus.toLowerCase() === 'trial')) {
            return true;
        }
        return false;
    }

    getPricingDetail(unformatedPricingDetail, planType) {
        let pricingDetail = '';
        if (unformatedPricingDetail) {
            pricingDetail = unformatedPricingDetail;
            if (pricingDetail.indexOf(' / ') >= 0) {
                pricingDetail = pricingDetail.replace(' / ', '/');
            }
            if (pricingDetail.indexOf('/ ') >= 0) {
                pricingDetail = pricingDetail.replace('/ ', '/');
            }
            if (pricingDetail.indexOf('for the first year') >= 0) {
                pricingDetail = pricingDetail.replace('for', ' for');
            }
        } else {
            if (planType.toLowerCase().indexOf('monthly') >= 0) {
                pricingDetail = "/month";
            } else {
                pricingDetail = "/year";
            }
        }
        return pricingDetail;
    }

    getEnvironment() {
        let environment;
        if (window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 || window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0) {
            environment = window.location.host.split('-')[1].split('.')[0];
        } else if (window.location.origin.indexOf('local') > 0) {
            environment = 'qa1';
        } else {
            environment = 'prod';
        }
        return environment;
    }

    paymentIframeUrl(currentEnvironment) {
        const paymentFrameURL = environment[currentEnvironment].paymentIframeURL;
        return paymentFrameURL;
    }

    public getFreshPassRegistrationLpMaster(currentEnvironment) {
      let url;
 
      if (this.banner === 'acmemarkets')  {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassLPMaster_Acme;
      } else if (this.banner === 'jewelosco') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassLPMaster_Jewelosco;
      } else {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassLpMaster;
      }
      return this._http.get(url, {responseType: 'text'});
    }

    public getFreshPassRegistrationBelowTilesMaster(currentEnvironment) {
      let url;
      
      if (this.banner === 'acmemarkets') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].belowTilesLPMaster_Acme;
      } else if (this.banner === 'jewelosco') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].belowTilesLpMaster_Jo;
      } else {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].belowTilesLpMaster;
      }

      return this._http.get(url, {responseType: 'text'});
    }

    public getFrequentlyAskedComponent(currentEnvironment) {
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassContentFAQ;
        return this._http.get(url, {responseType: 'text'});

    }

    public getTermsComponent(currentEnvironment) {
      let url;
      if(this.banner === 'acmemarkets') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassTerms_Acme;
      } else if (this.banner === 'jewelosco') {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassTerms_JO; 
      } else {
        url = this.getApplicationDomainURL() + environment[currentEnvironment].freshpassTerms;
      }
      return this._http.get(url, {responseType: 'text'}).pipe(
          map((data) => {
              data = data.replace(/\(displayableBanner\)/g,window['AB'].userInfo.displayableBanner);
              data = data.replace(/\(banner\)/g,window['AB'].userInfo.banner);
              data = data.replace(/\(banner4U\)/g,window['AB'].userInfo.displayableBanner);
              data = data.replace(/\(bannerName\)/g,window['AB'].userInfo.displayableBanner);
              return data;
          })
      );
    }

    public getPartnerData(discountCode: string, currentEnvironment: string, userInfo): Observable<any>  {
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].getPartnerDiscount.url + '?discountCode=' + discountCode;
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptions;

        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'x-swy-correlation-id': uuidv4(),
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': this.banner,
            }
        };
        return this._http.get(url, options);
    }

    private handleError(errorResponse: HttpErrorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            const errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
            return throwError(errMsg);
        }
    }
}
